import React from 'react';
import MediaEventReducer from './media-event-reducer';
import { DEFAULT_EVENT_STATE } from './media-event-statuses';
import type { MediaEventState } from './media-event-statuses';
import type { MediaEventAction } from './media-event-reducer';

export type MediaEventContextValue = [MediaEventState, React.Dispatch<MediaEventAction>];

export const MediaEventContext = React.createContext<MediaEventContextValue>(
  [DEFAULT_EVENT_STATE as MediaEventState, () => {}]
);

export const useMediaEventContext = (): MediaEventContextValue =>
  React.useContext(MediaEventContext);

interface MediaEventStoreProps {
  children: React.ReactNode;
}

const MediaEventStore = ({ children }: MediaEventStoreProps): React.ReactElement => {
  const [state, dispatch] = React.useReducer(MediaEventReducer, DEFAULT_EVENT_STATE as MediaEventState);
  return (
    <MediaEventContext.Provider value={[state, dispatch]}>
      {children}
    </MediaEventContext.Provider>
  );
};

export default MediaEventStore;
